import React, { useMemo } from "react";
import {
  ButtonMassActions,
  ButtonSmall,
  CheckBoxInput,
} from "../common/Buttons";
import ClientInfoComponent from "../Repetitive_components/clientInfoComponent";
import { exportDocument, prettyDateFormat } from "../../helpers/Utils";
import { IconDownload } from "../Layout/Icons";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Modal, Tooltip } from "antd";
import Axios from "axios";

const { confirm } = Modal;

export default function PickupAtTheStoreColumn({
  item,
  orderModal,
  selected,
  setSelected,
  setValue,
}) {
  const renderStatus = () => {
    switch (item.status) {
      case "ready":
        return "Ready";
      case "given_away":
        return "Given away";
      case "unprepared":
        return "Unprepared";
      case "change_mind":
        return "Change mind";
      case "pick_up":
        return "Pick up";
      case "canceled":
        return "Canceled";
      default:
        return "None";
    }
  };

  const order_documents = useMemo(() => {
    if (item.shipment.order?.order_documents?.length > 0) {
      return item.shipment.order.order_documents.filter(
        (d) => d.identifier == "invoice"
      );
    }
    return [];
  }, [item.shipment?.order?.order_documents?.length]);

  const shipment_documents = useMemo(() => {
    return item.shipment.shipment_documents.filter(
      (d) => d.identifier == "labels"
    );
  }, []);

  const actionsArr = useMemo(() => {
    if (item.finalized_at) return [];
    const callIt = async (status) => {
      try {
        const { data } = await Axios.post(
          `/api/v1/pickups/${item.id}/finalize?status=${status}`
        );
        if (data.success) {
          setValue((prev) => ({
            ...prev,
            data: prev.data.map((e) =>
              e.id == item.id ? { ...e, ...data.data } : e
            ),
          }));
        }
      } catch (err) {
        console.log("ERROR: ", err);
      }
    };
    return ["given_away", "change_mind", "pick_up"].map((d) => ({
      label: d[0].toUpperCase() + d.split("_").join(" ").slice(1),
      onFunction: () =>
        confirm({
          title: "Are you sure?",
          icon: <ExclamationCircleOutlined className="text-primary" />,
          content: "You will not be able to undo this action",
          onOk() {
            callIt(d);
            console.log("OK");
          },
          onCancel() {
            console.log("Cancel");
          },
        }),
    }));
  }, [item.status, item.finalized_at]);
  return (
    <tr className="align-middle tableColumn">
      <td className="align-middle">
        <CheckBoxInput checked={selected} onChange={() => setSelected()} />
      </td>
      <td className="align-middle">
        <a
          className="text-primary"
          onClick={() =>
            orderModal(
              item.shipment.order.id_order || `FO${item.shipment.order.id}`,
              item.shipment.order.id,
              "order"
            )
          }
        >
          {item.shipment.order.id_order || `FO${item.shipment.order.id}`}
        </a>
      </td>
      <td className="align-middle">{renderStatus()}</td>
      <td className="align-middle">{prettyDateFormat(item.updated_at)}</td>
      <td className="align-middle">
        {" "}
        <ClientInfoComponent
          client={item.shipment.order.billing_address}
          note_from_client={item.shipment.order.remark}
        />
      </td>
      <td className="align-middle">
        {item.shipment.shipment_order_rows.map((or_item) => (
          <OrderRowItem key={`order_row_${or_item.id}`} or_item={or_item} />
        ))}
      </td>
      <td className="align-middle">
        <p className="font-semi-bold text-sm mb-0">
          {item.shipment.pickup_address.code}
        </p>
        <p className="text-sm mb-0">
          {item.shipment.pickup_address.address},{" "}
          {item.shipment.pickup_address.city}
        </p>
      </td>
      <td className="align-middle">
        <div className="d-flex justify-content-end align-items-center">
          {order_documents?.length > 0 && (
            <>
              <ButtonMassActions
                text={<>Invoices </>}
                actions={order_documents.map((d) => ({
                  label: d.title,
                  onFunction: () => {
                    const a = document.createElement("a");
                    a.href = d.asset.url;
                    a.download = d.asset.url.split("/").pop();
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                  },
                }))}
              />
              <div className="mx-1"></div>
            </>
          )}
          {shipment_documents.length > 0 && (
            <>
              <Tooltip placement="top" title="Download label">
                <div>
                  <ButtonSmall
                    type="outline"
                    onClick={() => {
                      exportDocument(
                        `/api/v1/order_shipments/${item.shipment_id}/download`,
                        `${
                          item.shipment.shipment_type == "at_the_store"
                            ? "dpd"
                            : "lp_express"
                        }_${
                          item.shipment.order.id_order ||
                          item.shipment.order.number ||
                          `FO${item.shipment.order.id}`
                        }.pdf`,
                        "POST"
                      );
                    }}
                  >
                    <IconDownload color="#007BFF" />
                  </ButtonSmall>
                </div>
              </Tooltip>
              <div className="mx-1"></div>
            </>
          )}
          <Tooltip placement="top" title="Download pickup">
            <div>
              <ButtonSmall
                type="outline"
                onClick={() => {
                  exportDocument(
                    `/api/v1/pickups/${item.id}/pickup_download`,
                    `pickup_${
                      item.shipment.order.id_order ||
                      item.shipment.order.numberr ||
                      `FO${item.shipment.order.id}`
                    }.xlsx`,
                    "POST"
                  );
                }}
              >
                <IconDownload color="#007BFF" />
              </ButtonSmall>
            </div>
          </Tooltip>
          {actionsArr.length > 0 && (
            <>
              <div className="mx-1"></div>
              <ButtonMassActions
                color="#e61d01"
                text={<>Actions </>}
                actions={actionsArr}
              />
            </>
          )}
        </div>
      </td>
    </tr>
  );
}

const OrderRowItem = ({ or_item }) => {
  const order_row = () => {
    return (
      <>
        {or_item.quantity || Math.floor(or_item.order_row?.quantity)}
        &nbsp;*&nbsp;
        {or_item.order_row?.product_reference}
        &nbsp;
        {or_item.order_row?.product_name}
      </>
    );
  };
  return (
    <div className="d-flex flex-column">
      <div>{order_row()}</div>
      <br />
    </div>
  );
};

// const MarkProduct = ({ default_amount, order_id, order_row_id }) => {
//   const dispatch = useDispatch();
//   const [amount, setAmount] = useState(default_amount);
//   const [loading, setLoading] = useState(false);
//   const onSubmit = async () => {
//     try {
//       setLoading(true);
//       const data = await dispatch(
//         setOrderRowDisabledAt(
//           {
//             manual_quantity: amount,
//             disabled_at: true,
//           },
//           order_id,
//           order_row_id
//         )
//       );
//       console.log({ data });
//     } catch (err) {
//       console.log("ERROR: ", err);
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <div>
//       <TextInputModal
//         text="Amount"
//         value={amount}
//         onChange={(d) => setAmount(d.target.value)}
//       />
//       <div className="d-flex justify-content-end mt-2">
//         <BlueButton loading={loading} onClick={onSubmit}>
//           Submit
//         </BlueButton>
//       </div>
//     </div>
//   );
// };
